<template>
    <div class="about-page">
        <PageHeader title="关于我们" subtitle="与沃雷顿自行车一起创造未来" currentText="关于我们" :bgImage="topImage"/>
        <div class="gywmzhong">
            <h2 class="animate__animated animate__fadeInLeft wow">发展历程</h2>
            <p class="animate__animated animate__fadeInLeftBig wow">/&emsp;Company&nbsp;profile</p>
            <div class="gywmrunqi">
                <div :style="{ backgroundImage: `url(${require('@/assets/images/about/办公环境轮播2.jpg')})` }"
                    class="animate__animated animate__lightSpeedInLeft wow">

                </div>
                <div>
                    <p class="animate__animated animate__fadeInRightBig wow">
                        沃雷顿（VORLAD）源自六大核心理念，发展历程横跨欧中，以“认真做好车”为初心，完成从品牌引入到本土化深耕的跨越，其德国工艺底色与贴合用户的产品特质，是品牌核心竞争力。
                        沃雷顿品牌始于德国汉堡，1933年注册VORLAD品牌，开启自行车制造之路。
                        早期沃雷顿凭借德国工艺立足欧洲，以高强度钢材车架保障耐用稳定，设计兼顾典雅与人体工学。<br/>
                        2012年沃雷顿进入中国，由喜德盛旗下子公司代工销售，依托其供应链优势，形成兼具性价比与实用性的产品特点。
                        针对国内自行车市场两极分化的现状，沃雷顿推出多系列车型，车架采用轻量化铝合金与机器人焊接，核心配置搭载知名变速和制动系统，山地车配备避震前叉，设计贴合中国消费者习惯与审美，适配多场景需求。
                        品牌创新采用“专卖店”直供体系，以“六统一”标准快速扩张，半年内全国连锁店达50家，积累早期口碑。<br/>
                        2015年后，沃雷顿依托喜德盛产能优势优化产品矩阵，形成“高配置、高性价比、强适配”标签，推出很多爆款自行车。
                        山地车（如红日300）、公路车（如追风200）分别适配通勤越野、入门健身需求，休闲车注重便捷舒适，产品通过各种认证，“同价位配置更优”成为核心优势。
                        品牌深化服务理念， 2020年门店覆盖全国三十多个省市，成为中低端性价比市场代表性品牌。<br/>
                        2020年后，面对市场多元化与竞争加剧，沃雷顿在坚守性价比的基础上，向智能化、多元化转型。
                        品牌优化经典车型细节，同时探索车型与配件融合，推出儿童自行车系列，覆盖全年龄段用户，尝试新零售模式拓展年轻群体。<br/>
                        2023年后渠道虽有变动，但沃雷顿依托制造基础与用户口碑持续优化服务，其发展折射出中国自行车产业的演进，产品特点是品牌穿越周期的核心支撑。<br/>
                        沃雷顿跨越百年历程、横跨亚欧大陆，始终以德国严谨工艺为核心根基，以中国市场需求为导向，其产品跟随行业发展与用户需求迭代升级，始终秉持“以人为本”的核心原则，成为连接中德骑行文化的重要纽带。<br/>
                        沃雷顿将坚守“认真做好车”的初心使命，持续深耕产品创新与品质提升，不断优化产品矩阵与服务体系，为行业发展注入新活力，续写品牌高质量发展的骑行新篇章。
                    </p>
                </div>
            </div>
        </div>

        <!-- 关于我们轮播图 -->
        <div class="office">
            <p class="animate__animated animate__fadeInTopLeft wow">公司环境</p>
            <span class="animate__animated animate__flipInY wow">Company environment</span>
        </div>
        <div class="container">
            <el-carousel height="500px">
                <el-carousel-item key="1">
                    <div :style="{ backgroundImage: `url(${require('@/assets/images/about/办公环境轮播1.jpg')})` }"></div>
                </el-carousel-item>
                <el-carousel-item key="2">
                    <div :style="{ backgroundImage: `url(${require('@/assets/images/about/办公环境轮播2.jpg')})` }"></div>
                </el-carousel-item>
                <el-carousel-item key="3">
                    <div :style="{ backgroundImage: `url(${require('@/assets/images/about/办公环境轮播3.jpg')})` }"></div>
                </el-carousel-item>
                <el-carousel-item key="4">
                    <div :style="{ backgroundImage: `url(${require('@/assets/images/about/办公环境轮播4.jpg')})` }"></div>
                </el-carousel-item>
                <el-carousel-item key="5">
                    <div :style="{ backgroundImage: `url(${require('@/assets/images/about/办公环境轮播5.jpg')})` }"></div>
                </el-carousel-item>
            </el-carousel>
        </div>

        <!-- 公司介绍视频 -->
        <!-- <div class="company-video-section">
            <div class="page-container">
                <div class="section-header text-center">
                    <h2 class="section-title">公司介绍</h2>
                    <p class="section-desc">了解沃雷顿自行车的企业文化和发展历程</p>
                </div>
                <div class="video-container">
                    <el-image v-if="!isPlaying" :src="videoThumbnail" fit="cover" class="video-thumbnail"
                        @click="playCompanyVideo">
                        <div class="play-button">
                            <i class="el-icon-video-play"></i>
                        </div>
                    </el-image>
                    <video v-else ref="companyVideo" controls autoplay class="company-video" @ended="stopVideo">
                        <source :src="videoSource" type="video/mp4">
                        您的浏览器不支持视频播放
                    </video>
                </div>
            </div>
        </div> -->

        <!-- 团队介绍 -->
        <!-- <div class="team-section">
            <div class="page-container">
                <div class="section-header text-center">
                    <h2 class="section-title">核心团队</h2>
                    <p class="section-desc">沃雷顿自行车拥有一支充满激情和专业素养的精英团队</p>
                </div>
                <div class="team-container">
                    <div class="team-member" v-for="(member, index) in teamMembers" :key="index">
                        <div class="member-avatar">
                            <img :src="member.avatar" :alt="member.name">
                        </div>
                        <div class="member-info">
                            <h3 class="member-name">{{ member.name }}</h3>
                            <p class="member-position">{{ member.position }}</p>
                            <p class="member-description">{{ member.description }}</p>
                            <div class="member-social">
                                <a v-for="(social, idx) in member.social" :key="idx" :href="social.link"
                                    target="_blank">
                                    <i :class="social.icon"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- 企业文化 -->
        <div class="culture-section">
            <div class="page-container">
                <div class="section-header text-center">
                    <h2 class="section-title">企业文化与价值观</h2>
                    <p class="section-desc">了解沃雷顿自行车的企业文化和发展历程</p>
                </div>

                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :md="6" v-for="(value, index) in companyValues" :key="index">
                        <div class="value-card">
                            <div class="value-icon">
                                <el-icon :size="40">
                                    <component :is="value.icon" />
                                </el-icon>
                            </div>
                            <h3 class="value-title">{{ value.title }}</h3>
                            <p class="value-desc">{{ value.description }}</p>
                        </div>
                    </el-col>
                </el-row>
            </div>

        </div>

        <!-- 加入我们 -->
        <div class="page-container">
            <div class="join-us">

                <div class="join-us-content">
                    <h2>加入我们的团队</h2>
                    <p>我们始终寻找优秀的人才加入团队，共同创造美好未来。</p>
                    <router-link to="/recruits" class="el-button el-button--primary el-button--large">查看职位</router-link>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { ref, nextTick } from 'vue';
import PageHeader from '@/components/PageHeader.vue';

export default {
    components: {
        PageHeader,
    },
    setup() {
        const videoThumbnail = ref(require('@/assets/images/about/办公环境2.jpg'));
        const topImage = ref(require('@/assets/images/about/top.jpg'));
        const videoSource = ref('/videos/company-intro.mp4');
        const isPlaying = ref(false);
        const companyVideo = ref(null);

        const companyValues = ref([
            {
                title: '创新',
                icon: 'Setting',
                description: '不断探索新技术、新方法，推动行业发展。'
            },
            {
                title: '卓越',
                icon: 'Trophy',
                description: '追求卓越品质，精益求精，为客户创造最大价值。'
            },
            {
                title: '协作',
                icon: 'Connection',
                description: '团队协作，共同成长，实现集体智慧的最大化。'
            },
            {
                title: '诚信',
                icon: 'GoldMedal',
                description: '诚实守信，言行一致，赢得客户和合作伙伴信任。'
            }
        ]);

        // 播放公司介绍视频
        const playCompanyVideo = () => {
            isPlaying.value = true;
            // 确保DOM更新后再操作视频元素
            nextTick(() => {
                if (companyVideo.value) {
                    companyVideo.value.play();
                }
            });
        };

        // 停止视频播放
        const stopVideo = () => {
            isPlaying.value = false;
        };

        return {
            videoThumbnail,
            videoSource,
            isPlaying,
            companyVideo,
            companyValues,
            topImage,
            playCompanyVideo,
            stopVideo
        };
    }
}
</script>

<style lang="scss" scoped>
.gywmzhong {
    margin-top: 50px;
    padding-bottom: 5%;
}

.gywmzhong>h2 {
    margin: 0 0 20px 15%;
    font-size: 36px;
    font-weight: 900;
}

.gywmzhong>p {
    color: rgb(134, 134, 134);
    margin: 0 0 20px 15%;
    font-family: Franklin Gothic Medium;
}

.gywmrunqi {
    width: 70%;
    margin: 0 auto;
    display: flex;
    padding-bottom: 5%;

    @media (max-width: 992px) {
        flex-direction: column;
    }
}

.gywmrunqi>div {
    width: 100%;
}

.gywmrunqi>div:first-child {
    background-size: 100% 100%;
    height: 400px;
    filter: grayscale(30%);

    @media (max-width: 992px) {
        height: 300px;
    }
}

.gywmrunqi>div:last-child>p {
    line-height: 30px;
    letter-spacing: 0.3px;
    color: rgb(134, 134, 134);
    padding: 0 50px 0 50px;

    @media (max-width: 992px) {
        line-height: 20px;
        padding: 10px 0px 0 0px;
        letter-spacing: 0px;
    }
}

.office {
    width: 100%;
    height: 100px;
    background-color: #f5f7fa;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.office>p {
    font-size: 36px;
    font-weight: 900;
    margin: 0;
}

.office>span {
    font-size: 14px;
    color: rgb(134, 134, 134);
    font-family: Franklin Gothic Medium;
}

.container {
    width: 100%;
    margin: 0 auto;
    background-color: #f5f7fa;
    padding-bottom: 5%;

    ::v-deep(.el-carousel) {
        width: 80%;
        margin: 0 auto;
    }

    ::v-deep(.el-carousel__item) div {
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
    }
}

.company-video-section {
    padding: 80px 0;
    background-color: #fff;

    .video-container {
        max-width: 900px;
        margin: 50px auto 0;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        position: relative;

        .video-thumbnail {
            width: 100%;
            height: 500px;
            position: relative;
            cursor: pointer;

            .play-button {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 80px;
                height: 80px;
                background-color: rgba(0, 0, 0, 0.6);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.3s;

                i {
                    font-size: 40px;
                    color: #fff;
                }

                &:hover {
                    background-color: rgba(0, 0, 0, 0.8);
                    transform: translate(-50%, -50%) scale(1.1);
                }
            }
        }

        .company-video {
            width: 100%;
            height: 500px;
            object-fit: cover;
        }
    }
}

.team-section {
    padding: 80px 0;
    background-color: #f5f7fa;

    .team-container {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 30px;
        margin-top: 50px;

        @media (max-width: 1200px) {
            grid-template-columns: repeat(2, 1fr);
        }

        @media (max-width: 768px) {
            grid-template-columns: 1fr;
        }

        .team-member {
            background-color: #fff;
            border-radius: 10px;
            overflow: hidden;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
            transition: transform 0.3s, box-shadow 0.3s;

            &:hover {
                transform: translateY(-10px);
                box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
            }

            .member-avatar {
                height: 250px;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s;
                }

                &:hover img {
                    transform: scale(1.05);
                }
            }

            .member-info {
                padding: 20px;

                .member-name {
                    font-size: 20px;
                    font-weight: 600;
                    color: #333;
                    margin: 0 0 5px;
                }

                .member-position {
                    font-size: 14px;
                    color: #409EFF;
                    margin: 0 0 15px;
                    font-weight: 500;
                }

                .member-description {
                    font-size: 14px;
                    color: #666;
                    line-height: 1.6;
                    margin-bottom: 15px;
                }

                .member-social {
                    display: flex;
                    gap: 10px;

                    a {
                        width: 36px;
                        height: 36px;
                        border-radius: 50%;
                        background-color: #f5f5f5;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #666;
                        transition: all 0.3s;

                        &:hover {
                            background-color: #409EFF;
                            color: #fff;
                        }

                        i {
                            font-size: 18px;
                        }
                    }
                }
            }
        }
    }
}

/* 企业价值观 */
.culture-section {
    margin-bottom: 60px;
}

.value-card {
    background-color: #fff;
    border-radius: 8px;
    padding: 30px 20px;
    text-align: center;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    margin-bottom: 30px;
    height: calc(100% - 30px);
    transition: all 0.3s ease;
}

.value-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.value-icon {
    color: var(--el-color-primary);
    margin-bottom: 20px;
}

.value-title {
    font-size: 20px;
    margin-bottom: 15px;
}

.value-desc {
    color: #606266;
    font-size: 14px;
    line-height: 1.6;
}

/* 加入我们 */
.join-us {
    background: linear-gradient(135deg, var(--el-color-primary), var(--el-color-primary-light-3));
    border-radius: 8px;
    padding: 60px 40px;
    color: #fff;
    text-align: center;
    margin-bottom: 40px;
}

.join-us-content {
    max-width: 600px;
    margin: 0 auto;
}

.join-us h2 {
    font-size: 32px;
    margin-top: 0;
    margin-bottom: 15px;
}

.join-us p {
    font-size: 16px;
    margin-bottom: 30px;
    opacity: 0.9;
}

.join-us .el-button {
    font-size: 16px;
    padding: 12px 25px;
    background-color: #fff;
    color: var(--el-color-primary);
    border: none;
}

.join-us .el-button:hover {
    opacity: 0.9;
    background-color: #fff;
}

@media (max-width: 768px) {
    .section-title {
        font-size: 26px;
    }

    .section-desc {
        font-size: 14px;
    }

    .member-avatar {
        height: 250px;
    }

    .department-image {
        margin-right: 0;
        margin-bottom: 20px;
        max-width: 100%;
    }

    .department-header {
        flex-direction: column;
    }

    .join-us {
        padding: 40px 20px;
    }

    .join-us h2 {
        font-size: 26px;
    }
}

// fnegg --------------------------------------------
.section-header {
    margin-bottom: 30px;

    .section-title {
        font-size: 32px;
        font-weight: 700;
        color: #333;
        margin-bottom: 15px;
        position: relative;
        display: inline-block;

        &:after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 80px;
            height: 3px;
            background-color: #409EFF;
        }
    }

    .section-desc {
        font-size: 16px;
        color: #666;
        max-width: 700px;
        margin: 20px auto 0;
    }

    &.text-center {
        text-align: center;
    }
}

.page-container {
    max-width: 1200px;
    padding: 0 15px;
    margin: 0 auto;
}
</style>